import { useEffect, useState } from "react"
import { useFetch } from "../../../common/hooks/useFetch"
import { countTrainedEmployeesService } from "../services/countTrainedEmployees.service"

export const useTrainedEmployeesQuery = () => {
  const fetchData = useFetch()
  const [trainedEmployees, setTrainedEmployess] = useState(0)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchTrainedEmployees = async () => {
      try {
        setLoading(true)
        const response = await countTrainedEmployeesService(fetchData)()
        setTrainedEmployess(response)
      } catch (error) {
        console.error('Error:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchTrainedEmployees()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    trainedEmployees,
    loading
  }
}
